import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, Users, Award, Zap } from "lucide-react";

export const About = () => {
  const highlights = [
    {
      icon: <Users className="h-8 w-8 text-primary mb-4" />,
      title: "Especialistas Certificados",
      description: "Equipe com certificações Microsoft Power BI"
    },
    {
      icon: <Award className="h-8 w-8 text-primary mb-4" />,
      title: "Resultados Comprovados",
      description: "Mais de 100 projetos entregues com sucesso"
    },
    {
      icon: <Zap className="h-8 w-8 text-primary mb-4" />,
      title: "Tecnologia Avançada",
      description: "Soluções inovadoras e escaláveis"
    }
  ];

  const values = [
    "Transformar dados complexos em insights acionáveis",
    "Facilitar a vida dos nossos clientes e parceiros",
    "Oferecer soluções personalizadas em Power BI",
    "Automatizar processos de extração de dados",
    "Ajudar empresas a tomar decisões estratégicas",
    "Otimizar processos com base em dados confiáveis"
  ];

  return (
    <section id="sobre" className="py-20 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Sobre <span className="gradient-text">Nós</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Especialistas em transformar dados em resultados para sua empresa
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Left Column - Main Content */}
          <div className="animate-slide-up">
            <h3 className="text-2xl md:text-3xl font-semibold mb-6 text-foreground">
              Nossa Missão
            </h3>
            
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Somos especialistas em transformar dados complexos em visualizações claras e acionáveis. 
              Nossa missão é facilitar a vida dos nossos clientes e parceiros, oferecendo soluções 
              personalizadas em Power BI e automatizações de extração de dados.
            </p>

            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Com tecnologia avançada e expertise comprovada, ajudamos empresas a tomar decisões 
              estratégicas, otimizar processos e impulsionar resultados com base em dados confiáveis.
            </p>

            {/* Values List */}
            <div className="space-y-3">
              {values.map((value, index) => (
                <div key={index} className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-accent mt-0.5 mr-3 flex-shrink-0" />
                  <span className="text-foreground">{value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Highlights */}
          <div className="space-y-6 animate-slide-up" style={{ animationDelay: '200ms' }}>
            {highlights.map((highlight, index) => (
              <Card key={index} className="border-0 bg-gradient-card hover:shadow-card transition-shadow duration-300">
                <CardContent className="p-6">
                  <div className="text-center">
                    <div className="flex justify-center">
                      {highlight.icon}
                    </div>
                    <h4 className="text-xl font-semibold mb-2">{highlight.title}</h4>
                    <p className="text-muted-foreground">{highlight.description}</p>
                  </div>
                </CardContent>
              </Card>
            ))}

            {/* Stats */}
            <Card className="border-0 bg-gradient-primary text-white">
              <CardContent className="p-6">
                <div className="grid grid-cols-2 gap-4 text-center">
                  <div>
                    <div className="text-3xl font-bold text-accent mb-1">5+</div>
                    <div className="text-sm opacity-90">Anos de Experiência</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-accent mb-1">98%</div>
                    <div className="text-sm opacity-90">Satisfação dos Clientes</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};